import { ScreenMaker } from './screenMaker';
import { PresetCreator } from './presetCreator';
import { ElementsToSapElementsConverter } from './sap/elementsToSapElementsConverter';
import { Scene, Engine, Vector3, TransformNode } from '@babylonjs/core';
import { SceneConfiguration } from './sceneConfiguration';
import store from '@/store';
import Element, { ElementType } from './element';
import { opensManager } from './front/opensManager';
import { Product, ProductType } from '@/store/modules/product';
import { ProductDetailsManager } from './productDetailsManager';
import { presets } from './presets';

export class CallbackManager {

    private screenMaker: ScreenMaker;
    private presetCreator = new PresetCreator();
    private elementsToSapElementsConverter = new ElementsToSapElementsConverter();

    private get size(): any {
        const product: Product = store.getters.product;
        if (product.type === ProductType.BED ||
            product.type === ProductType.BEDSIDE_TABLE) {
            return {
                height: 800,
                width: 1200,
            };
        }
        return 800;
    }
    private center = true;

    private result: any = {
        data: {},
        graphics: {},
        extraData: {},
    };

    constructor(
        private scene: Scene,
        private engine: Engine,
        private sceneConfiguration: SceneConfiguration,
    ) {
        this.screenMaker = new ScreenMaker((x) => { });
    }

    public create(): any {
        this.screenMaker.preparePackshots(
            this.engine,
            this.scene,
            this.sceneConfiguration,
            this.size,
            this.center,
            this.onPackshotsReady,
        );
        return this.result;
    }

    private onPackshotsReady =
        (main: string, inner: string, back: string) => {
            const preset = this.presetCreator.create();
            const elements: Element[] = [];
            elements.push(...store.getters.scene.elements);
            elements.push(...store.getters.scene.backs);
            const backs: Element[] = store.getters.scene.backs;
            const productPreset = {
                ...store.getters.configuration.productPreset,
                dimension: {
                    width: Math.ceil(store.getters.product.width * 2) / 20,
                    height: Math.ceil(store.getters.product.height * 2) / 20,
                    depth: Math.ceil(store.getters.product.depth * 2) / 20,
                },
                dimension_full: {
                    width: store.getters.productFullWidth / 10,
                    height: store.getters.productFullHeight / 10,
                    depth: store.getters.productFullDepth / 10,
                },
            };
            const elements_erp = this.elementsToSapElementsConverter.convertAlone(elements);
            const price = store.getters.sap.calculation.value.price;

            opensManager.addOpens(preset.elements);

            this.result.data = preset;
            this.result.data.backs = backs;
            this.result.data['creative.price'] = price;
            this.result.data.elements_erp = elements_erp;
            this.result.data.productPreset = productPreset;
            this.result.data.pivot = this.calculateLowerPivot(elements);
            this.result.data.tapes = this.calculateTapes();
            const productDetailsManager = new ProductDetailsManager(this.result.data);
            this.result.data.productDetails = productDetailsManager.crete();

            this.result.graphics.main = main;
            this.result.graphics.inner = inner;
            this.result.graphics.back = back;

            this.result.extraData = this.createExtraData();
        }

    private createExtraData(): any {
        const result: any = {};
        result.presetIndex = presets.indexOfSelectedPreset;
        return result;
    }

    private calculateLowerPivot(elements: Element[]): Vector3 {
        const legs = elements.find((x) =>
            x.type === ElementType.LEGS &&
            x.shaderName !== 'ShaderNPodp',
        );
        if (legs) {
            const bounding = (legs.root.getChildren()[0] as TransformNode).getHierarchyBoundingVectors();
            return new Vector3(
                bounding.min.x + (bounding.max.x - bounding.min.x) / 2,
                bounding.min.y,
                bounding.min.z + (bounding.max.z - bounding.min.z) / 2,
            );
        }
        const body = elements.find((x) => x.type === ElementType.BODY);
        const bounding = (body.root.getChildren()[0] as TransformNode).getHierarchyBoundingVectors();
        return new Vector3(
            bounding.min.x + (bounding.max.x - bounding.min.x) / 2,
            bounding.min.y,
            bounding.min.z + (bounding.max.z - bounding.min.z) / 2,
        );
    }

    private calculateTapes(): string {
        const body: Element = store.getters.body;
        return body.meshes
            .filter((x) =>
                x.name.includes('tasma') &&
                x.visibility === 1,
            )
            .map((x) => {
                const splitted = x.name.split('_');
                return splitted[splitted.length - 1];
            })
            .sort()
            .join('');
    }
}
